var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"g-recaptcha",attrs:{"id":"recaptcha","data-sitekey":_vm.siteKey,"data-action":"checkout"},on:{"click":_vm.clearError}}),(_vm.error)?_c('p',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }